export class PaymentMethodType {
  bankAccounts: any;
  code: string;
  currency: string;
  displayName: string;
  loyaltyPoints: boolean;
  name: string;
  paymentTypeCode: string;
  pointValue: number;
  availableOnThisSalesOrg: string;

  constructor() {
    this.code = "";
    this.currency = "";
    this.displayName = "";
    this.loyaltyPoints = false;
    this.name = "";
    this.paymentTypeCode = "";
    this.pointValue = 0;
    this.availableOnThisSalesOrg = "";
  }
}
